import React from 'react';
import { tokens } from '../../theme';

export const Asterisk = ({ error }: { error?: boolean }) => {
  return (
    <span
      aria-hidden="true"
      className={`MuiFormLabel-asterisk ${error ? 'Mui-error' : ''}`}
      style={{ color: tokens.colorAlert }}
    >
      *
    </span>
  );
};
